<!-- Sendgroup without actors (temp for drag and drop - move to other sendgroups) -->
<ng-container *ngIf="(groupedActors === undefined || groupedActors.length === 0) && sendgroup.name === '_SendGroup'">
  <div [id]="sendgroup.sendGroupGuid" class="hidden-sendgroup"
    cdkDropList
    [cdkDropListConnectedTo]="getConnectedList()"
    [cdkDropListData]="groupedActors"
    (cdkDropListDropped)="dropItem($event)"
    cdkDrag
    (cdkDropListEntered)="enter($event, sendgroup.sendGroupGuid)"
    (cdkDropListExited)="exit($event, sendgroup.sendGroupGuid)">
      <!-- Skeleton if temp sendgroup item entered -->
    <app-skeleton-send-groups *ngIf="isLoading"></app-skeleton-send-groups>
  </div>
</ng-container>


<!-- If sendgroup + actors -->
<div class="mt-2 mb-4" *ngIf="groupedActors.length > 0">
    <p class="default-font-size">
        <b>{{ getTranslatedSendGroupName(sendgroup.name) }}</b>
    </p>
    <div class="w-100 p-3 sendGroup">
        <div class="row row-cols-12">
            <div class="mb-3 col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
                <label for="name" class="form-label" translate="Request.Send.SendGroupName"></label>
                <input type="text" (focusout)="updateSendGroup('name', $event)" id="name" class="form-control" [value]="getTranslatedSendGroupName(sendgroup.name)">
            </div>
            <div class="mb-3 col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
                <label for="sendGroupSendDate" class="form-label" translate="Request.Send.SendDate"></label>
                <input *ngIf="isFirstSendGroup" type="text" disabled (focusout)="updateSendGroup('sendDate', $event)" id="sendGroupSendDate" class="form-control" placeholder="{{ 'Request.Send.Now' | translate }}">
                <input *ngIf="!isFirstSendGroup" type="text" disabled (focusout)="updateSendGroup('sendDate', $event)" id="sendGroupSendDate" class="form-control" value="{{ 'Request.Send.Latest' | translate }}: {{getPreviousDeadlineAsString(sendgroup.sendDate)}} ">
            </div>
            <div class="mb-3 col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
                <label for="sendGroupDeadline" class="form-label" translate="Request.Send.Deadline"></label>
                <ng-container *ngIf="isFirstSendGroup">
                    <datetime-picker (changeSendDate)="changeSendDate($event)" (changeSendDate)="updateSendGroup('deadlineDate', $event)" [previousDeadlineDate]="sendgroup.deadline"></datetime-picker>
                </ng-container>
                <ng-container *ngIf="!isFirstSendGroup">
                    <div ngbDropdown class="col-12 float-start dropdown" ngDefaultControl name="deadline" id="deadline">
                        <button class="btn default actions dropdown-toggle text-truncate" type="button" id="dropdownMenu"
                            ngbDropdownToggle>
                            <span *ngIf="sendgroup.deadlineDays === 1" translate=Request.Send.DeadlineDay
                                [translateParams]="{days: sendgroup.deadlineDays}"></span>
                            <span *ngIf="sendgroup.deadlineDays > 1 && sendgroup.deadlineDays < 31" translate="Request.Send.DeadlineDays"
                                [translateParams]="{days: sendgroup.deadlineDays}"></span>
                            <span *ngIf="sendgroup.deadlineDays === 31" translate="Request.Send.DeadlineMonth"
                                [translateParams]="{month: 1}"></span>
                            <span *ngIf="sendgroup.deadlineDays > 31" translate="Request.Send.DeadlineMonths"
                                [translateParams]="{months: sendgroup.deadlineDays === 62 ? 2 : 3}"></span>
                            <em class="bi bi-chevron-down float-end" aria-hidden="true"></em>
                        </button>
                        <div class="dropdownMenuTime col-12 actions-dropdown" ngbDropdownMenu aria-labelledby="dropdownMenu">
                            <button ngbDropdownItem *ngFor="let days of [1, 2, 3, 4, 5, 6, 7, 10, 14, 21, 31, 62, 93]"
                                value={{days}} (click)="updateSendGroup('deadlineDays', days)">
                                <span *ngIf="days === 1" translate=Request.Send.DeadlineDay
                                    [translateParams]="{days: days}"></span>
                                <span *ngIf="days > 1 && days < 31" translate="Request.Send.DeadlineDays"
                                    [translateParams]="{days: days}"></span>
                                <span *ngIf="days === 31" translate="Request.Send.DeadlineMonth"
                                    [translateParams]="{month: 1}"></span>
                                <span *ngIf="days > 31" translate="Request.Send.DeadlineMonths"
                                    [translateParams]="{months: days === 62 ? 2 : 3}"></span>
                            </button>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
        <!-- <desktop-builder-sendgroup-table [sendgroup]="sendgroup" [sendgroups]="sendgroups"></desktop-builder-sendgroup-table> -->
      <div>
        <ul 
        class="d-none d-lg-block list-group"
        id={{sendgroup.sendGroupGuid}}
        cdkDropList
        [cdkDropListData]="groupedActors"
        (cdkDropListDropped)="dropItem($event)"
        [cdkDropListConnectedTo]="getConnectedList()">
          <li class="list-group-item subheader sg-actions d-block pt-1 pe-0 pb-1 ps-2">
            <div class="row row-cols-10 w-100 d-flex p-0 align-items-center">
              <div class="col-4 text-truncate firstcol"><span translate="Request.Send.Person"></span></div>
              <div class="col-2 text-truncate"><span translate="Request.Send.Action"></span></div>
              <div class="col-4 text-truncate"><span translate="Request.Send.Documents"></span></div>
              <div class="col-1 text-truncate"><span translate="Request.Send.Credits"></span></div>
              <div class="col-1 text-end"></div>
            </div>
          </li>
          <ng-container *ngFor="let actorInSendgroup of groupedActors; int let i = index; let firstitem = first; let lastitem = last;">
            <ng-container *ngIf="!actorInSendgroup.grouped">
              <li class="list-group-item d-block pt-1 pe-0 pb-1 ps-2 subtable" cdkDrag cdkDragLockAxis="y" [cdkDragData]="actorInSendgroup" (cdkDragStarted)="dragStarted($event)" (cdkDragEnded)="dragEnded($event)">
                <desktop-builder-sendgroup-action-table-row [actorInSendgroup]="actorInSendgroup" [showMenu]="true"></desktop-builder-sendgroup-action-table-row>
              </li>
            </ng-container>
            <ng-container *ngIf="actorInSendgroup.grouped">
              <li class="list-group-item d-block pt-1 pe-0 pb-1 ps-2 subtable grouped test" cdkDragLockAxis="y" (click)="collapseCurrentSendgroup(actorInSendgroup.id)" cdkDrag [cdkDragData]="actorInSendgroup" (cdkDragStarted)="dragStarted($event)" (cdkDragEnded)="dragEnded($event)" [ngClass]="{ 'last-child-collapsed': lastitem && isCurrentSendGroupCollapsed(actorInSendgroup.id),  'no-bottom-border': !isCurrentSendGroupCollapsed(actorInSendgroup.id) }">
                <desktop-builder-sendgroup-action-table-row [actorInSendgroup]="actorInSendgroup" [showMenu]="true"></desktop-builder-sendgroup-action-table-row>
              </li>

              <div #collapse="ngbCollapse" [id]="actorInSendgroup.id" [ngbCollapse]="isCurrentSendGroupCollapsed(actorInSendgroup.id)" [horizontal]="false" [ngClass]="{ 'last-child-expanded': lastitem && !isCurrentSendGroupCollapsed(actorInSendgroup.id) }">
                <!-- Expandable list of actions by person -->
                <app-actions-by-person [actorInSendgroup]="actorInSendgroup" [sortingAllowed]="sortingAllowed" [lastItemOfPersonsInSendgroup]="lastitem"></app-actions-by-person>
              </div>

            </ng-container>
          </ng-container>
      
        </ul>
      </div>
    </div>
</div>